import {InitialStructWhithBlock, MPos, simpleSize} from "@3dcalc/3dpClient/dist/types/types";
import {
    createDefaultMaterial,
    RenderElement,
    RenderStruct
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {CP, initParam} from "../setting/initParam";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";


export async function getBlock(s:InitialStructWhithBlock, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []

    rs.material.push(createDefaultMaterial())

    CP.maps.block.line = [
        [-(s.l + s.block.w) / 2 + initParam.elementData.block1.sizeBoard.w / 2 + initParam.elementData.cladding.sizeBoard.h , 0],
        [-(s.l + s.block.w) / 2 + s.block.w - initParam.elementData.block1.sizeBoard.w / 2 - initParam.elementData.cladding.sizeBoard.h, 0]
    ]

    const line = CP.maps.block.line

    const nameGroup = 'block'
    rs.group = nameGroup

    const specIdVertical = `${nameGroup}-vertical`
    const specIdHorizontal = `${nameGroup}-horizontal`

    // ── Вертикальные стойки ──────────────────────────────────────────────────
    const board1 = await api.getSimpleBoard.build({
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {
            w: sBoard.w,
            h: sBoard.h,
            l: 0
                + initParam.elementData.f1.sizeBoard.w
                - initParam.gash.simple * 3
                + initParam.elementData.f2.sizeBoard.l
                + initParam.elementData.block1.sizeBoard.h
        },
        cuts: [],
    })

    rs.uvs.push(board1.mesh.uvs)
    const numUvs1 = rs.uvs.length - 1
    rs.indices.push(board1.mesh.indices)
    const numIndices1 = rs.indices.length - 1
    rs.vertices.push(board1.mesh.vertices)
    const numVertices1 = rs.vertices.length - 1

    for (let i = 0; i < line.length; i++) {
        const x = line[i][0]

        const posL: MPos = [
            x,
            s.h + board1.meta.l / 2 + initParam.elementData.block1.sizeBoard.h / 2,
            +initParam.elementData.ridge.sizeBoard.w / 2 - sBoard.h / 2]
        const posR: MPos = [
            x,
            s.h + board1.meta.l / 2 + initParam.elementData.block1.sizeBoard.h / 2,
            -initParam.elementData.ridge.sizeBoard.w / 2 + sBoard.h / 2]

        const boardL: RenderElement = {
            indices: numIndices1,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [0, 0, 0],
            uvs: numUvs1,
            vertices: numVertices1,
            material: 0,
            specId: specIdVertical,
        }
        rs.elements.push(boardL)

        const boardR: RenderElement = {
            indices: numIndices1,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            rotation: [0, 0, 0],
            uvs: numUvs1,
            vertices: numVertices1,
            material: 0,
            specId: specIdVertical,
        }
        rs.elements.push(boardR)
    }

    spec.push({
        w: board1.meta.w,
        h: board1.meta.h,
        l: board1.meta.l,
        name: "Стойка хозблока",
        group: nameGroup,
        count: line.length * 2,
        specId: specIdVertical,
    })
    specIds.push(specIdVertical)

    // ── Горизонтальные балки ─────────────────────────────────────────────────
    const board2 = await api.getSimpleBoard.build({
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: s.w - initParam.elementData.harness.sizeBoard.w * 2},
        cuts: [],
    })

    rs.uvs.push(board2.mesh.uvs)
    const numUvs2 = rs.uvs.length - 1
    rs.indices.push(board2.mesh.indices)
    const numIndices2 = rs.indices.length - 1
    rs.vertices.push(board2.mesh.vertices)
    const numVertices2 = rs.vertices.length - 1

    const z = -s.w / 2 + board2.meta.l / 2 + initParam.elementData.harness.sizeBoard.w

    for (let i = 0; i < line.length; i++) {
        const x = line[i][0]

        const boardH: RenderElement = {
            indices: numIndices2,
            name: `${nameGroup} - h${i}`,
            nameGroup: nameGroup,
            position: [x, s.h, z],
            rotation: [Math.PI / 2, 0, 0],
            uvs: numUvs2,
            vertices: numVertices2,
            material: 0,
            specId: specIdHorizontal,
        }
        rs.elements.push(boardH)
    }

    spec.push({
        w: board2.meta.w,
        h: board2.meta.h,
        l: board2.meta.l,
        name: "Балка хозблока",
        group: nameGroup,
        count: line.length,
        specId: specIdHorizontal,
    })
    specIds.push(specIdHorizontal)

    rs.specIds = specIds

    return {rs: rs, spec: spec}
}
